"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProtocolVersion = getProtocolVersion;
exports.getSyncing = getSyncing;
exports.getGasPrice = getGasPrice;
exports.getMaxPriorityFeePerGas = getMaxPriorityFeePerGas;
exports.getAccounts = getAccounts;
exports.getBlockNumber = getBlockNumber;
exports.getBalance = getBalance;
exports.getStorageAt = getStorageAt;
exports.getTransactionCount = getTransactionCount;
exports.getBlockTransactionCountByHash = getBlockTransactionCountByHash;
exports.getBlockTransactionCountByNumber = getBlockTransactionCountByNumber;
exports.getCode = getCode;
exports.sign = sign;
exports.signTransaction = signTransaction;
exports.sendTransaction = sendTransaction;
exports.sendRawTransaction = sendRawTransaction;
exports.call = call;
exports.estimateGas = estimateGas;
exports.getBlockByHash = getBlockByHash;
exports.getBlockByNumber = getBlockByNumber;
exports.getTransactionByHash = getTransactionByHash;
exports.getTransactionByBlockHashAndIndex = getTransactionByBlockHashAndIndex;
exports.getTransactionByBlockNumberAndIndex = getTransactionByBlockNumberAndIndex;
exports.getTransactionReceipt = getTransactionReceipt;
exports.getCompilers = getCompilers;
exports.compileHyperion = compileHyperion;
exports.newFilter = newFilter;
exports.newBlockFilter = newBlockFilter;
exports.newPendingTransactionFilter = newPendingTransactionFilter;
exports.uninstallFilter = uninstallFilter;
exports.getFilterChanges = getFilterChanges;
exports.getFilterLogs = getFilterLogs;
exports.getLogs = getLogs;
exports.getFeeHistory = getFeeHistory;
exports.getPendingTransactions = getPendingTransactions;
exports.requestAccounts = requestAccounts;
exports.getChainId = getChainId;
exports.getProof = getProof;
exports.getNodeInfo = getNodeInfo;
exports.createAccessList = createAccessList;
exports.signTypedData = signTypedData;
const web3_validator_1 = require("@theqrl/web3-validator");
function getProtocolVersion(requestManager) {
    return __awaiter(this, void 0, void 0, function* () {
        return requestManager.send({
            method: 'qrl_protocolVersion',
            params: [],
        });
    });
}
function getSyncing(requestManager) {
    return __awaiter(this, void 0, void 0, function* () {
        return requestManager.send({
            method: 'qrl_syncing',
            params: [],
        });
    });
}
function getGasPrice(requestManager) {
    return __awaiter(this, void 0, void 0, function* () {
        return requestManager.send({
            method: 'qrl_gasPrice',
            params: [],
        });
    });
}
function getMaxPriorityFeePerGas(requestManager) {
    return __awaiter(this, void 0, void 0, function* () {
        return requestManager.send({
            method: 'qrl_maxPriorityFeePerGas',
            params: [],
        });
    });
}
function getAccounts(requestManager) {
    return __awaiter(this, void 0, void 0, function* () {
        return requestManager.send({
            method: 'qrl_accounts',
            params: [],
        });
    });
}
function getBlockNumber(requestManager) {
    return __awaiter(this, void 0, void 0, function* () {
        return requestManager.send({
            method: 'qrl_blockNumber',
            params: [],
        });
    });
}
function getBalance(requestManager, address, blockNumber) {
    return __awaiter(this, void 0, void 0, function* () {
        web3_validator_1.validator.validate(['address', 'blockNumberOrTag'], [address, blockNumber]);
        return requestManager.send({
            method: 'qrl_getBalance',
            params: [address, blockNumber],
        });
    });
}
function getStorageAt(requestManager, address, storageSlot, blockNumber) {
    return __awaiter(this, void 0, void 0, function* () {
        web3_validator_1.validator.validate(['address', 'hex', 'blockNumberOrTag'], [address, storageSlot, blockNumber]);
        return requestManager.send({
            method: 'qrl_getStorageAt',
            params: [address, storageSlot, blockNumber],
        });
    });
}
function getTransactionCount(requestManager, address, blockNumber) {
    return __awaiter(this, void 0, void 0, function* () {
        web3_validator_1.validator.validate(['address', 'blockNumberOrTag'], [address, blockNumber]);
        return requestManager.send({
            method: 'qrl_getTransactionCount',
            params: [address, blockNumber],
        });
    });
}
function getBlockTransactionCountByHash(requestManager, blockHash) {
    return __awaiter(this, void 0, void 0, function* () {
        web3_validator_1.validator.validate(['bytes32'], [blockHash]);
        return requestManager.send({
            method: 'qrl_getBlockTransactionCountByHash',
            params: [blockHash],
        });
    });
}
function getBlockTransactionCountByNumber(requestManager, blockNumber) {
    return __awaiter(this, void 0, void 0, function* () {
        web3_validator_1.validator.validate(['blockNumberOrTag'], [blockNumber]);
        return requestManager.send({
            method: 'qrl_getBlockTransactionCountByNumber',
            params: [blockNumber],
        });
    });
}
function getCode(requestManager, address, blockNumber) {
    return __awaiter(this, void 0, void 0, function* () {
        web3_validator_1.validator.validate(['address', 'blockNumberOrTag'], [address, blockNumber]);
        return requestManager.send({
            method: 'qrl_getCode',
            params: [address, blockNumber],
        });
    });
}
function sign(requestManager, address, message) {
    return __awaiter(this, void 0, void 0, function* () {
        web3_validator_1.validator.validate(['address', 'hex'], [address, message]);
        return requestManager.send({
            method: 'qrl_sign',
            params: [address, message],
        });
    });
}
// TODO - Validation should be:
// isTransactionWithSender(transaction)
// ? validateTransactionWithSender(transaction)
// : validateTransactionWithSender(transaction, true) with true being a isPartial flag
function signTransaction(requestManager, transaction) {
    return __awaiter(this, void 0, void 0, function* () {
        return requestManager.send({
            method: 'qrl_signTransaction',
            params: [transaction],
        });
    });
}
// TODO - Validation should be:
// isTransactionWithSender(transaction)
// ? validateTransactionWithSender(transaction)
// : validateTransactionWithSender(transaction, true) with true being a isPartial flag
function sendTransaction(requestManager, transaction) {
    return __awaiter(this, void 0, void 0, function* () {
        return requestManager.send({
            method: 'qrl_sendTransaction',
            params: [transaction],
        });
    });
}
function sendRawTransaction(requestManager, transaction) {
    return __awaiter(this, void 0, void 0, function* () {
        web3_validator_1.validator.validate(['hex'], [transaction]);
        return requestManager.send({
            method: 'qrl_sendRawTransaction',
            params: [transaction],
        });
    });
}
// TODO - validate transaction
function call(requestManager, transaction, blockNumber) {
    return __awaiter(this, void 0, void 0, function* () {
        // validateTransactionCall(transaction);
        web3_validator_1.validator.validate(['blockNumberOrTag'], [blockNumber]);
        return requestManager.send({
            method: 'qrl_call',
            params: [transaction, blockNumber],
        });
    });
}
// TODO Not sure how to best validate Partial<TransactionWithSender>
function estimateGas(requestManager, transaction, blockNumber) {
    return __awaiter(this, void 0, void 0, function* () {
        web3_validator_1.validator.validate(['blockNumberOrTag'], [blockNumber]);
        return requestManager.send({
            method: 'qrl_estimateGas',
            params: [transaction, blockNumber],
        });
    });
}
function getBlockByHash(requestManager, blockHash, hydrated) {
    return __awaiter(this, void 0, void 0, function* () {
        web3_validator_1.validator.validate(['bytes32', 'bool'], [blockHash, hydrated]);
        return requestManager.send({
            method: 'qrl_getBlockByHash',
            params: [blockHash, hydrated],
        });
    });
}
function getBlockByNumber(requestManager, blockNumber, hydrated) {
    return __awaiter(this, void 0, void 0, function* () {
        web3_validator_1.validator.validate(['blockNumberOrTag', 'bool'], [blockNumber, hydrated]);
        return requestManager.send({
            method: 'qrl_getBlockByNumber',
            params: [blockNumber, hydrated],
        });
    });
}
function getTransactionByHash(requestManager, transactionHash) {
    return __awaiter(this, void 0, void 0, function* () {
        web3_validator_1.validator.validate(['bytes32'], [transactionHash]);
        return requestManager.send({
            method: 'qrl_getTransactionByHash',
            params: [transactionHash],
        });
    });
}
function getTransactionByBlockHashAndIndex(requestManager, blockHash, transactionIndex) {
    return __awaiter(this, void 0, void 0, function* () {
        web3_validator_1.validator.validate(['bytes32', 'hex'], [blockHash, transactionIndex]);
        return requestManager.send({
            method: 'qrl_getTransactionByBlockHashAndIndex',
            params: [blockHash, transactionIndex],
        });
    });
}
function getTransactionByBlockNumberAndIndex(requestManager, blockNumber, transactionIndex) {
    return __awaiter(this, void 0, void 0, function* () {
        web3_validator_1.validator.validate(['blockNumberOrTag', 'hex'], [blockNumber, transactionIndex]);
        return requestManager.send({
            method: 'qrl_getTransactionByBlockNumberAndIndex',
            params: [blockNumber, transactionIndex],
        });
    });
}
function getTransactionReceipt(requestManager, transactionHash) {
    return __awaiter(this, void 0, void 0, function* () {
        web3_validator_1.validator.validate(['bytes32'], [transactionHash]);
        return requestManager.send({
            method: 'qrl_getTransactionReceipt',
            params: [transactionHash],
        });
    });
}
function getCompilers(requestManager) {
    return __awaiter(this, void 0, void 0, function* () {
        return requestManager.send({
            method: 'qrl_getCompilers',
            params: [],
        });
    });
}
function compileHyperion(requestManager, code) {
    return __awaiter(this, void 0, void 0, function* () {
        web3_validator_1.validator.validate(['string'], [code]);
        return requestManager.send({
            method: 'qrl_compileHyperion',
            params: [code],
        });
    });
}
function newFilter(requestManager, filter) {
    return __awaiter(this, void 0, void 0, function* () {
        web3_validator_1.validator.validate(['filter'], [filter]);
        return requestManager.send({
            method: 'qrl_newFilter',
            params: [filter],
        });
    });
}
function newBlockFilter(requestManager) {
    return __awaiter(this, void 0, void 0, function* () {
        return requestManager.send({
            method: 'qrl_newBlockFilter',
            params: [],
        });
    });
}
function newPendingTransactionFilter(requestManager) {
    return __awaiter(this, void 0, void 0, function* () {
        return requestManager.send({
            method: 'qrl_newPendingTransactionFilter',
            params: [],
        });
    });
}
function uninstallFilter(requestManager, filterIdentifier) {
    return __awaiter(this, void 0, void 0, function* () {
        web3_validator_1.validator.validate(['hex'], [filterIdentifier]);
        return requestManager.send({
            method: 'qrl_uninstallFilter',
            params: [filterIdentifier],
        });
    });
}
function getFilterChanges(requestManager, filterIdentifier) {
    return __awaiter(this, void 0, void 0, function* () {
        web3_validator_1.validator.validate(['hex'], [filterIdentifier]);
        return requestManager.send({
            method: 'qrl_getFilterChanges',
            params: [filterIdentifier],
        });
    });
}
function getFilterLogs(requestManager, filterIdentifier) {
    return __awaiter(this, void 0, void 0, function* () {
        web3_validator_1.validator.validate(['hex'], [filterIdentifier]);
        return requestManager.send({
            method: 'qrl_getFilterLogs',
            params: [filterIdentifier],
        });
    });
}
function getLogs(requestManager, filter) {
    return __awaiter(this, void 0, void 0, function* () {
        web3_validator_1.validator.validate(['filter'], [filter]);
        return requestManager.send({
            method: 'qrl_getLogs',
            params: [filter],
        });
    });
}
function getFeeHistory(requestManager, blockCount, newestBlock, rewardPercentiles) {
    return __awaiter(this, void 0, void 0, function* () {
        web3_validator_1.validator.validate(['hex', 'blockNumberOrTag'], [blockCount, newestBlock]);
        for (const rewardPercentile of rewardPercentiles) {
            web3_validator_1.validator.validate(['number'], [rewardPercentile]);
        }
        return requestManager.send({
            method: 'qrl_feeHistory',
            params: [blockCount, newestBlock, rewardPercentiles],
        });
    });
}
function getPendingTransactions(requestManager) {
    return __awaiter(this, void 0, void 0, function* () {
        return requestManager.send({
            method: 'qrl_pendingTransactions',
            params: [],
        });
    });
}
function requestAccounts(requestManager) {
    return __awaiter(this, void 0, void 0, function* () {
        return requestManager.send({
            method: 'qrl_requestAccounts',
            params: [],
        });
    });
}
function getChainId(requestManager) {
    return __awaiter(this, void 0, void 0, function* () {
        return requestManager.send({
            method: 'qrl_chainId',
            params: [],
        });
    });
}
function getProof(requestManager, address, storageKeys, blockNumber) {
    return __awaiter(this, void 0, void 0, function* () {
        web3_validator_1.validator.validate(['address', 'bytes32[]', 'blockNumberOrTag'], [address, storageKeys, blockNumber]);
        return requestManager.send({
            method: 'qrl_getProof',
            params: [address, storageKeys, blockNumber],
        });
    });
}
function getNodeInfo(requestManager) {
    return __awaiter(this, void 0, void 0, function* () {
        return requestManager.send({
            method: 'web3_clientVersion',
            params: [],
        });
    });
}
function createAccessList(requestManager, transaction, blockNumber) {
    return __awaiter(this, void 0, void 0, function* () {
        web3_validator_1.validator.validate(['blockNumberOrTag'], [blockNumber]);
        return requestManager.send({
            method: 'qrl_createAccessList',
            params: [transaction, blockNumber],
        });
    });
}
function signTypedData(requestManager_1, address_1, typedData_1) {
    return __awaiter(this, arguments, void 0, function* (requestManager, address, typedData, useLegacy = false) {
        // TODO Add validation for typedData
        web3_validator_1.validator.validate(['address'], [address]);
        return requestManager.send({
            method: `qrl_signTypedData${useLegacy ? '' : '_v4'}`,
            params: [address, typedData],
        });
    });
}
//# sourceMappingURL=qrl_rpc_methods.js.map